import SgdfBadge from './badge.component.js';
export * from './badge.component.js';
export default SgdfBadge;
SgdfBadge.define('sgdf-badge');
//# sourceMappingURL=badge.js.map